export type TournamentStatus = 'Draft' | 'Registration' | 'Active' | 'Paused' | 'Completed' | 'Cancelled' | 'Archived';

export type StatusAction = 'publish' | 'cancel' | 'pause' | 'resume';

interface StatusTransition {
    label: string;
    action: StatusAction;
    confirmMessage: string;
}

const statusTransitions: Record<TournamentStatus, StatusTransition[]> = {
    Draft: [
        {
            label: 'Publish',
            action: 'publish',
            confirmMessage: 'Are you sure you want to publish this tournament?',
        },
    ],
    Registration: [
        {
            label: 'Cancel',
            action: 'cancel',
            confirmMessage: 'Are you sure you want to cancel this tournament?',
        },
    ],
    Active: [
        {
            label: 'Pause',
            action: 'pause',
            confirmMessage: 'Are you sure you want to pause this tournament?',
        },
        {
            label: 'Cancel',
            action: 'cancel',
            confirmMessage: 'Are you sure you want to cancel this tournament?',
        },
    ],
    Paused: [
        {
            label: 'Resume',
            action: 'resume',
            confirmMessage: 'Are you sure you want to resume this tournament?',
        },
    ],
    Completed: [],
    Cancelled: [],
    Archived: [],
};

export const getAvailableTransitions = (status: TournamentStatus): StatusTransition[] => {
    return statusTransitions[status] || [];
};
